import * as React from 'react';
import { breadcrumbsDriverFactory } from './Breadcrumbs.driver';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { createRendererWithUniDriver } from '../../test/utils';
import { Breadcrumbs } from '.';
import { simpleItemsExample } from './exampleItems';

describe('Breadcrumbs', () => {
  const render = createRendererWithUniDriver(breadcrumbsDriverFactory);

  it('should render', async () => {
    const { driver } = render(<Breadcrumbs items={simpleItemsExample} />);
    expect(await driver.exists()).toBe(true);
  });

  it('should add the correct text', async () => {
    const { driver } = render(<Breadcrumbs items={simpleItemsExample} />);
    expect(await driver.getBreadcrumbContentAt(0)).toBe('Breadcrumb 1');
  });

  it('should call onClick function when clicking Breadcrumb', async () => {
    const onClick = jest.fn();
    const { driver } = render(
      <Breadcrumbs items={simpleItemsExample} onClick={onClick} />,
    );

    await driver.clickBreadcrumbAt(0);

    expect(onClick).toHaveBeenCalledWith(simpleItemsExample[0]);
  });

  it('should render in mobile mode', async () => {
    const { driver } = render(
      <TPAComponentsProvider value={{ mobile: true }}>
        <Breadcrumbs items={simpleItemsExample} data-hook="breadcrumbs" />
      </TPAComponentsProvider>,
      'breadcrumbs',
    );
    expect(await driver.isMobile()).toBe(true);
  });

  it('should call onClick function when clicking Breadcrumb in NoTrail mobile mode with the previous breadcrumb item', async () => {
    const onClick = jest.fn();

    const { driver } = render(
      <TPAComponentsProvider value={{ mobile: true }}>
        <Breadcrumbs
          items={simpleItemsExample}
          showTrailOnMobileMode={false}
          onClick={onClick}
          data-hook="breadcrumbs"
        />
      </TPAComponentsProvider>,
      'breadcrumbs',
    );

    await driver.clickBreadcrumbAt(0);
    expect(onClick).toHaveBeenCalledWith(simpleItemsExample[1]);
  });

  it('should render the correct number of items', async () => {
    const { driver } = render(
      <Breadcrumbs items={[simpleItemsExample[0], simpleItemsExample[1]]} />,
    );
    expect(await driver.getBreadcrumbsLength()).toBe(2);
  });
});
